const dateSelect = {
    /**
    * @param {Date} date
    * @returns {any[]}
    */
    getDateTable: (date) => {
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        var weeks = [];

        for (var d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
            if (weeks.length == 0 || d.getDay() == 1) {
                weeks.push([]);
            }
            weeks[weeks.length - 1].push(d);
        }
        return weeks;
    },

    ///**
    //* @returns {Date}
    //*/
    //getCalendarDate: () => {
    //    var date = $('input[name=date]').val();
    //    if (!date) {
    //        var today = new Date();
    //        today.setDate(1);
    //        date = today.toISOString()
    //        $('input[name=date]').val(date);
    //    }
    //    var dateobj = new Date(date);

    //    return dateobj;
    //},

    isSelected: () => {
        return !!dateSelect.selectedDate;
    },
    getAgenda: () => {
        return $('input[name=agenda-ident]').val();
    },
    loadTable: () => {
        var date = dateSelect.calendarDate;
        var agenda = $('input[name=agenda-ident]').val();
        $.ajax({
            url: "/Home/GetCalendar",
            data: {
                agenda: agenda,
                date: date.toISOString()
            }
        }).done(function (data) {
            dateSelect.fillTable(data);
        });
    },

    getMonthString: function (objDate) {

        var locale = "cs-cz",
            month = objDate.toLocaleString(locale, { month: "long", year: "numeric" });

        return stringHelper.capitalize(month);
    },

    loadTimes: function (times) {
        if (!times) {
            $('#times-body').text('');
        }
        var template = document.getElementById('times-template').innerHTML;

        for (var i = 0; i < times.length; i++) {
            var time = times[i];
            time.id = i;
            var cssClass = "";
            if (time.available == true) {
                
            } else {
                cssClass = "time__link--disabled";
            }

            var startDate = new Date(time.start);
            var hour = ('0' + startDate.getHours()).slice(-2);
            var minute = ('0' + startDate.getMinutes()).slice(-2);
            time.time = hour + ":" + minute;
            time.class = cssClass;
            time.date = startDate;
        }

        var html = Mustache.render(template, times);
        document.getElementById('times-body').innerHTML = html;

        $('#next-btn').addClass('btn--disabled');

        $('.time__link').click(function (e) {
            e.preventDefault();
            var id = $(this).attr('data-id');
            var time = times[id];

            $('.time__link').not(this).removeClass('time__link--selected');           

            $(this).toggleClass('time__link--selected');
            $(this).blur();

            if ($(this).hasClass('time__link--selected')) {
                dateSelect.selectedDate = time.date;
                var agenda = dateSelect.getAgenda();
                dateSelect.setUrl('/Home/Reserve?agendaIdent=' + encodeURI(agenda) + '&date=' + encodeURI(dateSelect.selectedDate.toISOString()))
            } else {
                dateSelect.selectedDate = null;
                dateSelect.setUrl('#');
            }

            $('body').focus();
            $('#next-btn').toggleClass('btn--disabled', !dateSelect.isSelected());

        });
    },

    setUrl: function (url) {
        $('#next-btn').attr('href', url);
    },

    calendarDate: new Date(),
    selectedDate: null,

    nextMonth: () => {
        var currentDate = new Date();
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        currentDate.setDate(1);
        var date = dateSelect.calendarDate;
        date.setMonth(date.getMonth() + 1);
        if (date < currentDate) date = currentDate;
        dateSelect.calendarDate = date;
        dateSelect.loadTable();
    },

    prevMonth: () => {
        var currentDate = new Date();
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        currentDate.setDate(1);
        var date = dateSelect.calendarDate;
        date.setMonth(date.getMonth() - 1);
        if (date < currentDate) date = currentDate;
        dateSelect.calendarDate = date;
        dateSelect.loadTable();
    },

    fillTable: function(data) {
        console.log(data);
        $('#next-btn').addClass('btn--disabled');
        if (!data || !data.days || data.days.length == 0)
            return;
        var template = document.getElementById('calendar-template').innerHTML;

        var days = data.days;
        var weeks = [[]];

        var currentDate = new Date();
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());


        for (var i = 0; i < days.length; i++) {
            var day = days[i];
            var date = new Date(day.date);
            var datedow = dateHelper.dayOfWeek(date);
            var cssclass = "";

            day.disabled = false;
            if (date < currentDate || day.holiday === true) {
                day.disabled = "true";
            } else {
                if (!day.available) {
                    cssclass = "calendar__link--unselectable";
                }

                if (dateHelper.isToday(date)) {
                    cssclass += " calendar__link--today";
                }
            }

            day.class = cssclass.trim();
            day.url = "#";
            day.dayNumber = date.getDate();
            day.id = i;

            weeks[weeks.length - 1].push(day);
            if (datedow == 6 && i < (days.length - 1)) {
                weeks.push([]);
            }
        }
        while (weeks[0].length < 7) {
            weeks[0].unshift(null);
        }

        while (weeks[weeks.length - 1].length < 7) {
            weeks[weeks.length - 1].push(null);
        }
        console.log(weeks);
        document.getElementById('calendar-body').innerHTML = Mustache.render(template, weeks);
        $('.calendar__month').text(dateSelect.getMonthString(dateSelect.calendarDate))

        $('.calendar__link').click(function (e) {
            e.preventDefault();
            var id = $(this).attr('data-id');
            var day = days[id];
            dateSelect.loadTimes(day.times);
            $('.calendar__link').removeClass('calendar__link--selected');
            $(this).addClass('calendar__link--selected');
        });
    },

    init: () => {
        $('.calendar__prev').click(function (e) {
            e.preventDefault();
            dateSelect.prevMonth();
        });

        $('.calendar__next').click(function (e) {
            e.preventDefault();
            dateSelect.nextMonth();
        });
        dateSelect.calendarDate = new Date();
        dateSelect.loadTable();
    }

}
